var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClosed = function SvgClosed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#495966"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 8.25V10H13.8125V8.25C13.8125 7.04688 12.8281 6.0625 11.625 6.0625C10.3945 6.0625 9.4375 7.04688 9.4375 8.25ZM8.125 10V8.25C8.125 6.33594 9.68359 4.75 11.625 4.75C13.5391 4.75 15.125 6.33594 15.125 8.25V10H16C16.957 10 17.75 10.793 17.75 11.75V17C17.75 17.9844 16.957 18.75 16 18.75H7.25C6.26562 18.75 5.5 17.9844 5.5 17V11.75C5.5 10.793 6.26562 10 7.25 10H8.125ZM6.8125 11.75V17C6.8125 17.2461 7.00391 17.4375 7.25 17.4375H16C16.2188 17.4375 16.4375 17.2461 16.4375 17V11.75C16.4375 11.5312 16.2188 11.3125 16 11.3125H7.25C7.00391 11.3125 6.8125 11.5312 6.8125 11.75Z",
    fill: "white"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closed.dcc522c8.svg";
export { ForwardRef as ReactComponent };